<lib-modal #modal>
  <lib-modal-dialog class="file-upload-modal">
    <lib-modal-dialog-header class="file-upload-modal__header" [hideCloseIcon]="true">
      <div class="file-upload-modal__header-title-container">
        <span class="mfile-upload-modal__header-title">{{ title }}</span>

        <span
          class="file-upload-modal__header-close-icon"
          [ngClass]="{'file-upload-modal__header-close-icon--disabled': isCloseIconDisabled}"
          (click)="onCloseIconClick()"
          >&#10005;</span
        >
      </div>
    </lib-modal-dialog-header>

    <lib-modal-dialog-body class="file-upload-modal__body">
      <div class="file-upload-modal__body-header">
        <span class="file-upload-modal__body-header-title">Select file</span>
      </div>

      <div class="file-upload-modal__body-content">
        <div class="file-upload-modal__section file-upload-modal__section--primary">
          <ng-content select=".file-upload-modal__left-section"></ng-content>
        </div>

        <div class="file-upload-modal__section-divider"></div>

        <div class="file-upload-modal__section file-upload-modal__section--secondary">
          <ng-content select=".file-upload-modal__right-section"></ng-content>
        </div>
      </div>

      <ng-template [ngIf]="isFileUploading">
        <div class="file-upload-modal__loader">
          <lib-loader>Uploading file. Please wait ...</lib-loader>
        </div>
      </ng-template>
    </lib-modal-dialog-body>

    <lib-modal-dialog-footer class="file-upload-modal__footer">
      <div class="file-upload-modal__button-group">
        <lib-button
          class="file-upload-modal__button"
          [busy]="isUploadButtonBusy"
          [disabled]="isUploadButtonDisabled"
          (click)="onButtonClick(fileUploadModalActions.Upload)"
        >
          Upload
        </lib-button>

        <lib-button
          class="file-upload-modal__button"
          [type]="buttonType.Secondary"
          [disabled]="isCancelButtonDisabled"
          (click)="onButtonClick(fileUploadModalActions.Cancel)"
        >
          Cancel
        </lib-button>
      </div>
    </lib-modal-dialog-footer>
  </lib-modal-dialog>
</lib-modal>
